export enum OttopilotOtpWorkspaceCapabilityAccessOperation {
    create = "1445fe88-d6c7-45b4-b596-c45413c189c8",
    read = "d2c96411-85f5-478a-8127-c40918760d45",
    update = "78c76fd4-ed8b-4b93-98f6-fa534691c7f7",
    delete = "7531b56a-d0aa-470f-9b3b-5e7e0fb988d3",
}
